import React, { useEffect, useState } from "react";

import { useSelector, useDispatch } from "react-redux";
import { setCityName , } from "../../store/citySlice";
import { useLocation } from "react-router-dom";

import {
  getCartTotal,
  removeItem,
  decreaseItemQuantity,
  increaseItemQuantity,
} from "../../store/cartSlice";
import ConfirmBookingForm from "./ConfirmBookingForm";
import ViewCartComponentOld from "../cart/ViewCartComponentOld";
import ViewCartComponent from "../cart/ViewCartComponent";
import ChooseLocation from "../cart/ChooseLocation";
import ChooseLocationFemale from "../cart/ChooseLocationFemale";

const CartComponent = () => {
  const [cartList, setCartList] = useState(false);

  const [confirmForm, setConfirmForm] = useState(false);

  const [showChooseLocation, setChooseLocation] = useState(false)
  const [showFmchooseLocation ,  setShowFmchooseLocation] = useState(false)

  // --------------------------------------------------------------------------------------------
  
  const location = useLocation();

  const { cart, totalQuantity, totalPrice } = useSelector(
    (state) => state.allCart
  );

  const selectedcityName = useSelector(state => state.city.cityName);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getCartTotal());
    // ;;;;;;;;;;;;;;;;changes of card list ::::::::::::::::::::::::::::::
  
    
   
    if(selectedcityName !=null ){

    setCartList(true)
  }else{

    if(location.pathname==="/mens-grooming-home/noida3"){
      setCartList(true)
    }
  }


    if(selectedcityName == null){

      if(location.pathname === "/salon-for-women-at-home"){

        setShowFmchooseLocation(true)
      }else{
        setChooseLocation(true)
      }


    }

  }, [cart]);
  

  // console.log(selectedcityName)
  // console.log("first", cart)

  return (
    <div>
      {confirmForm ? (
        <ConfirmBookingForm setConfirmForm={setConfirmForm} crt={cart} />
      ) : (
        ""
      )}
      {cart.length <= 0 ? (
        ""
      ) : (
        <div className="cart-fix-col">
          <div
            className="cart-fix-col-text"
            onClick={(e) => setCartList(!cartList)}
          >
            Total Amount : <span> Rs. {totalPrice} /-</span>
          </div>
          <div
            className="cart-fix-button"
            onClick={(e) => setCartList(!cartList)}
          >
            <div>{cart.length}</div>
            {/* {totalQuantity} */}
            <i className="fa-solid fa-cart-shopping"></i>
          </div>
        </div>
      )}

      {/* ------------------------------------------------------------- */}

      {
      // cartList ? 
      cart.length > 0 && cartList ?
      (
        //  <ViewCartComponentOld setCartList={setCartList} cartList={cartList} setConfirmForm={setConfirmForm}/>
        <ViewCartComponent
          setCartList={setCartList}
          // cartList={cartList}
          setConfirmForm={setConfirmForm}
        />
      ) : (
        ""
      )}
{
  
  cart.length >0 && showChooseLocation ===true ?

  <div> 
    <ChooseLocation   setChooseLocation={setChooseLocation}   setCartList={setCartList}/>
  </div>
  :""

}




{
  
  cart.length >0 && showFmchooseLocation ===true ?

  <div> 
    <ChooseLocationFemale   setShowFmchooseLocation={setShowFmchooseLocation}   setCartList={setCartList}/>
  </div>
  :""

}




    </div>
  );
};

export default CartComponent;
